export default "__VITE_ASSET__C1FSo8Rw__"